import axios from 'axios'
import navigator from '@/utils/navigator.js'
import i18n from '@/i18n';
import { baseURL } from '@/config.js'
import store from '@/store'
// 必须显式引入 Element UI 的组件
import { Message, Loading } from 'element-ui';

const instance = axios.create({
	baseURL,
	timeout: 5000,
	withCredentials: true
})

let loadingInstance = null; // 用于存储 Loading 实例
let isRedirecting = false;  // 401 防并发锁

// --- 内部方法：开启加载 ---
function startLoading() {
	loadingInstance = Loading.service({
		lock: true,
		text: i18n.t('加载中...'),
		spinner: 'el-icon-loading',
		background: 'rgba(255, 255, 255, 0.7)'
	});
}

// --- 内部方法：关闭加载 ---
function stopLoading() {
	if (loadingInstance) {
		loadingInstance.close();
		loadingInstance = null;
	}
}

instance.interceptors.request.use(
	config => {
		// 1. Token 和 语言 设置
		const token = localStorage.getItem('token')
		if (token) config.headers.token = token
		config.headers.lang = localStorage.getItem('defaultLang') || 'zh'

		// 2. 处理 Loading 逻辑 (支持通过 config 动态关闭)
		const showLoading = config.showLoading ?? true; // 推荐直接在 config 层传参
		if (showLoading) {
			startLoading();
		}

		return config
	},
	error => {
		stopLoading();
		return Promise.reject(error)
	}
)

instance.interceptors.response.use(
	response => {
		stopLoading();
		const data = response.data
		// 如果业务 code 不为 1，弹出错误提示
		if (data.code !== 1) {
			Message.error(data.msg || 'Error');
		}
		return data
	},
	error => {
		stopLoading();
		const { response } = error
		// 处理 401 登录失效
		if (response && response.status === 401) {
			if (isRedirecting) return new Promise(() => { })
			isRedirecting = true
			Message.error(i18n.t('登录失效，请重新登录'))
			// 清理状态
			localStorage.removeItem('token')
			store.commit('setToken', '');
			setTimeout(() => {
				navigator.go('/')
				setTimeout(() => { isRedirecting = false }, 1000)
			}, 1000)

			return new Promise(() => { })
		}

		// 处理其他状态码错误
		if (response) {
			Message.error(response.data?.msg || `HTTP Error: ${response.status}`)
		} else {
			// 处理断网或超时
			Message.error(i18n.t('网络错误，请检查连接'))
		}

		return Promise.reject(error)
	}
)

export default instance